import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGratipay } from "@fortawesome/free-brands-svg-icons";

const Header: React.FC = () => {
	return (
		<div className="mb-2">
			<h1><FontAwesomeIcon icon={faGratipay} /> <a href="/">整形外科診断ツール</a></h1>
			<p>整形外科疾患の範囲で気になるからだの症状や年齢などから考えられる病気や対応方法をご提案いたします。</p>
			<p>診断ツールが正常に起動しない場合は、少し時間をおいてから再度、ツールのご利用をお願いします。</p>
		</div>
	);
};

export { Header };

